import { render, staticRenderFns } from "./empresaext.vue?vue&type=template&id=16ff542c&"
import script from "./empresaext.vue?vue&type=script&lang=js&"
export * from "./empresaext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports